export const EMPTY_OBJECT = {};
export const EMPTY_ARRAY: [] = [];
export const EMPTY_MAP = new Map();
export const EMPTY_SET = new Set<any>();
